import { Document } from 'src/app/modules/core/store/models/document.model';
import { Dataset } from './dataset.model';
import { Layer } from '../../../cop/store/cop/models';

export interface CameraWithMediaDto {
  key: string;
  id: string;
  displayName?: string;
  videoStreams?: CameraMediaDto[];
  thumbnails?: CameraMediaDto[];
  isActive?: boolean;
  provider?: string;
}

export interface CameraMediaDto {
  width: number;
  height: number;
  codec: string;
  authenticatedUrl: string;
  authType?: VmsAuthenticationType;
  userName: string;
  password: string;
  token?: string;
  stunServer?: string;
  mediaFormat?: MediaFormat;
}

export enum VmsAuthenticationType {
  BasicHttp = 0,
  Https = 1
}

export enum MediaFormat {
  None = 0,
  Mjpeg = 1,
  H264 = 2,
  Jpeg = 3
}

export interface VideoStream {
  documentUId?: string;
  name?: string;
  imageUrl?: string;
  imageRefreshRate?: number;
  videoUrl?: string;
  videoType?: string;
  document?: Document;
  layerUId?: string;
  type?: VideoStreamType;
  lat?: string;
  lon?: string;
  cameraId?: string;
  liveUnitId?: string;
  token?: string;
  stunServer?: string;
  serverUrl?: string;
  integrationKey?: string;
  fromCameras?: boolean;
  layer?: Layer;
  dataset?: Dataset;
  hasGeometry?: boolean;
  width?: string;
  height?: string;
  coding?: string;
  container?: string;
  pipelineDefinitionUId?: string;
}

export enum VideoStreamType {
  None = 0,
  Traffic = 1,
  Salient = 2,
  Avigilon = 3,
  ExacqVision = 4,
  OpenEye = 5,
  Milestone = 6,
  MAXPRO = 7,
  IP = 8,
  LiveView = 9
}

export interface VideoStreamUrlRequest {
  cameraId: string;
  videoStreamType?: VideoStreamType;
  startTime: string;
  endTime?: string;
  integrationKey?: string;
  companyId?: string;
  deviceId?: string;
  streamName?: string;
  pipelineDefinitionUId?: string;
  cameraProvider?: string;
}

export const VideoMimeTypes = {
  'MPEG-TS': 'application/x-mpegURL',
  'MP4': 'video/mp4',
  'FLV': 'video/x-flv',
  'RTP': 'rtsp'
};
